export const MODES_VALUES = ["VIEW", "CREATE", "EDIT", "MOVE", "DELETE", "ZONES"] as const;

export type MODES = typeof MODES_VALUES[number];
